import './App.css';
import { Routes, Route, NavLink } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilCalendar, cilNewspaper, cilInbox, cilUserFollow, cilTags, cilInstitution } from '@coreui/icons';
import ArticlesList from './Components/Articles/ArticlesList';
import EventsList from './Components/EventsList';
import ArticleEditor from './Components/Articles/ArticleEditor';
import ArticlesUnsorted from './Components/Articles/ArticlesUnsorted';
import Categories from './Components/Categories';
import Entities from "./Components/Entities";
import UserSubmissions from "./Components/UserSubmissions";
import AuthGuard from './Components/AuthGuard';
import { getCurrentUser, logout } from './core/auth';

const NAV_ITEMS = [
  { to: '/', label: 'Events', icon: cilCalendar, end: true },
  { to: '/articles', label: 'Articles', icon: cilNewspaper },
  { to: '/unsorted', label: 'Unsorted', icon: cilInbox },
  { to: '/user-submissions', label: 'User submissions', icon: cilUserFollow },
  { to: '/categories', label: 'Categories', icon: cilTags },
  { to: '/entities', label: 'Entities', icon: cilInstitution },
];

function App() {
  const email = getCurrentUser()?.email || '';
  const initial = email.charAt(0).toUpperCase() || '?';

  return (
    <AuthGuard>
      <div className="flex flex-row" data-theme="sentinel">
        <aside className="bg-slate-900 h-screen w-[212px] text-slate-200 fixed left-0 top-0 flex flex-col">
          <div className="flex items-center gap-2 px-4 h-14 border-b border-slate-800">
            <span className="w-6 h-6 rounded bg-red-600 flex items-center justify-center text-white text-xs font-bold">
              RS
            </span>
            <span className="font-semibold text-sm text-white">Red Sentinel</span>
          </div>

          <nav className="flex-1 py-3 px-2 space-y-0.5">
            {NAV_ITEMS.map(({ to, label, icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${
                    isActive ? 'bg-red-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                  }`
                }
              >
                <CIcon icon={icon} className="w-4 h-4 shrink-0" />
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="p-3 border-t border-slate-800 flex items-center gap-2">
            <span className="w-7 h-7 rounded-full bg-slate-700 flex items-center justify-center text-xs font-semibold shrink-0">
              {initial}
            </span>
            <span className="flex-1 text-xs text-slate-400 truncate" title={email}>
              {email}
            </span>
            <button
              className="btn btn-ghost btn-xs text-slate-400 hover:text-white"
              onClick={() => logout()}
              title="Sign out"
            >
              Sign out
            </button>
          </div>
        </aside>

        <main className="p-6 w-full ml-[212px] min-h-screen bg-base-200">
          <Routes>
            <Route path="/" element={<EventsList />} />
            <Route path="/articles" element={<ArticlesList />} />
            <Route path="/article/:articleId" element={<ArticleEditor />} />
            <Route path="/unsorted" element={<ArticlesUnsorted />} />
            <Route path="/user-submissions" element={<UserSubmissions />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/entities" element={<Entities />} />
          </Routes>
        </main>
      </div>
    </AuthGuard>
  );
}

export default App;
